/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IIdOrCreatedAtOrUpdatedAtOrTitleOrTitleContextOrDescriptionOrDescriptionContextOrChallengeTypeCodeOrEquipmentTypeCodeOrThumbnailImageOrBannerImageOr11MoreOrIsTranslationFinalized {
  Id = 'id',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
  Title = 'title',
  TitleContext = 'titleContext',
  Description = 'description',
  DescriptionContext = 'descriptionContext',
  ChallengeTypeCode = 'challengeTypeCode',
  EquipmentTypeCode = 'equipmentTypeCode',
  ThumbnailImage = 'thumbnailImage',
  BannerImage = 'bannerImage',
  SeriesId = 'seriesId',
  Subtext = 'subtext',
  SubtextContext = 'subtextContext',
  Intensity = 'intensity',
  Rating = 'rating',
  NecessaryWorkouts = 'necessaryWorkouts',
  SeasonalCount = 'seasonalCount',
  SeasonalTimeFrame = 'seasonalTimeFrame',
  StartDate = 'startDate',
  EndDate = 'endDate',
  RedemptionLink = 'redemptionLink',
  IsTranslationFinalized = 'isTranslationFinalized',
}
